module.exports = {
	"ha": "bc",
	"id": 5.6,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by PWID Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.6365118174409,
						"dataLabels": {
							"enabled": true,
							"format": "2396"
						}
					},
					{
						"y": 88.14180929095355,
						"dataLabels": {
							"enabled": true,
							"format": "2163"
						}
					},
					{
						"y": 82.51833740831296,
						"dataLabels": {
							"enabled": true,
							"format": "2025"
						}
					},
					{
						"y": 74.00162999185004,
						"dataLabels": {
							"enabled": true,
							"format": "1816"
						}
					},
					{
						"y": 56.234718826405874,
						"dataLabels": {
							"enabled": true,
							"format": "1380"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.18731117824774,
						"dataLabels": {
							"enabled": true,
							"format": "4875"
						}
					},
					{
						"y": 88.43907351460221,
						"dataLabels": {
							"enabled": true,
							"format": "4391"
						}
					},
					{
						"y": 83.86706948640483,
						"dataLabels": {
							"enabled": true,
							"format": "4164"
						}
					},
					{
						"y": 79.37562940584088,
						"dataLabels": {
							"enabled": true,
							"format": "3941"
						}
					},
					{
						"y": 69.10372608257805,
						"dataLabels": {
							"enabled": true,
							"format": "3431"
						}
					},
					{
						"y": null
					},
					{
						"y": 77.66097240473061,
						"dataLabels": {
							"enabled": true,
							"format": "2364"
						}
					},
					{
						"y": 45.893561103810775,
						"dataLabels": {
							"enabled": true,
							"format": "1397"
						}
					},
					{
						"y": 41.88567674113009,
						"dataLabels": {
							"enabled": true,
							"format": "1275"
						}
					},
					{
						"y": 38.5676741130092,
						"dataLabels": {
							"enabled": true,
							"format": "1174"
						}
					},
					{
						"y": 33.01576872536137,
						"dataLabels": {
							"enabled": true,
							"format": "1005"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.3634881825590925,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.72454090150251,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.380027739251037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.32098765432099,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.008810572687224,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.8126888217522619,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.928205128205125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.169665224322473,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.355427473583097,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.940877949758944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -22.33902759526938,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40.90524534686971,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.732999284180387,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.921568627450981,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.395229982964219,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=2454"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=4965"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3044"
			}
		],
		"dataTable": {
			"IDU": [
				2454,
				2396,
				2163,
				2025,
				1816,
				1380
			],
			"Non-IDU": [
				4965,
				4875,
				4391,
				4164,
				3941,
				3431
			],
			"Unknown": [
				3044,
				2364,
				1397,
				1275,
				1174,
				1005
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_6.json
// module id = 170
// module chunks = 0